import React, { createElement } from 'react';
// Module-level side effect: runs BEFORE React mounts.
if (typeof document !== 'undefined') {
  const head = document.head;
  const ensureLink = (rel: string, href: string, attrs: Record<string, string> = {}) => {
    if (head.querySelector(`link[rel="${rel}"][href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    head.appendChild(link);
  };
  // Preconnect to image CDN only — we no longer load any Google Fonts.
  ensureLink('preconnect', 'https://images.weserv.nl');
  // CRITICAL INLINE CSS: paints the hero correctly before the Tailwind bundle
  // finishes loading. Uses the SYSTEM font stack — no Google Fonts request,
  // no font-swap-induced LCP recalculation. Saves ~1.5s on slow 4G.
  if (!head.querySelector('style[data-critical="hero"]')) {
    const style = document.createElement('style');
    style.setAttribute('data-critical', 'hero');
    style.textContent = `
      html,body{margin:0;padding:0;background:#0A1628;color:#E8EAF0;font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',sans-serif;line-height:1.5;-webkit-text-size-adjust:100%;font-display:optional}
      *,*::before,*::after{box-sizing:border-box}
      h1,h2,h3,h4,h5,h6{margin:0;font-weight:700;letter-spacing:-0.015em;color:#fff}
      h1{font-size:1.875rem;line-height:1.15;text-align:center}
      @media(min-width:640px){h1{font-size:2.25rem}}
      @media(min-width:768px){h1{font-size:3rem}}
      @media(min-width:1024px){h1{font-size:3.75rem}}
      p{margin:0}
      img{max-width:100%;height:auto;display:block}
      a{color:inherit;text-decoration:none}
      button{font-family:inherit;cursor:pointer;border:0;background:transparent}
      #root{min-height:100vh;background:#0A1628}
    `;
    head.appendChild(style);
  }
}
export function PreloadAssets() {
  return null;
}